import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, HandshakeIcon, CogIcon, SparklesIcon, LayoutGridIcon, ShieldCheckIcon } from 'lucide-react';
const features = [{
  icon: BuildingIcon,
  title: "Europe's Largest Kia Showroom",
  description: 'Unrivalled selection and direct access to new vehicles.'
}, {
  icon: HandshakeIcon,
  title: 'Premium Trade Partnerships',
  description: "Exclusive relationships with the UK's top conversion specialists."
}, {
  icon: CogIcon,
  title: 'In-House Engineering Team',
  description: 'Experienced professionals delivering precision craftsmanship.'
}, {
  icon: SparklesIcon,
  title: 'Proprietary Products',
  description: "Unique innovations you won't find anywhere else."
}, {
  icon: LayoutGridIcon,
  title: 'Every Configuration Available',
  description: 'From weekend escapes to full-time living, we build to your vision.'
}, {
  icon: ShieldCheckIcon,
  title: 'PV5 Specialists',
  description: 'Dedicated expertise in this remarkable vehicle.'
}];
export function WhyChooseUs() {
  return <section className="relative w-full bg-dark-800 py-24 md:py-32 overflow-hidden" data-id="element-278">
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/3 rounded-full blur-3xl" data-id="element-279" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-281">
          <p className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4 font-body" data-id="element-282">
            Why Choose Us
          </p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold" data-id="element-283">
            What Sets Vanscape <span className="text-gold italic" data-id="element-284">Apart</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-285">
          {features.map((feature, i) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 25
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex gap-5 p-6 rounded-xl bg-dark-900/40 border border-white/5 hover:border-gold/20 transition-all duration-400" data-id="element-286">
              <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-gold/10 flex items-center justify-center" data-id="element-287">
                <feature.icon className="text-gold" size={22} data-id="element-288" />
              </div>
              <div data-id="element-289">
                <h3 className="font-display text-lg font-semibold mb-2" data-id="element-290">
                  {feature.title}
                </h3>
                <p className="text-white/50 text-sm leading-relaxed font-body" data-id="element-291">
                  {feature.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}